// Resource constants for role-based access control
export const RESOURCES = {
  EXTERNAL_USERS: 'external-users',
  PROFILE: 'profile',
  ADMIN_USERS: 'admin-users',
  ROLE_GROUPS: 'role-groups',
  FORM: 'form',
  SUBFORM: 'subform',
  EXTERNAL_ORGANIZATIONS_CATEGORIES: 'external-users-categories', // value kept for backend compatibility
  WORKFLOWS: 'workflows',
  REQUESTS: 'requests',
  ORG_STRUCTURE: 'org-structure',
  NOTIFICATIONS_SLA: 'notifications-sla',

  // Payments
  PAYMENTS: 'payments',

  // Audit Logs
  ADMIN_USERS_LOGS: 'admin-users-logs',
  EXTERNAL_USERS_LOGS: 'external-users-logs',
  EXTERNAL_ORGANIZATIONS_CATEGORIES_LOGS: 'external-users-categories-logs', // value kept for backend compatibility
  ROLE_GROUPS_LOGS: 'role-groups-logs',
  FORM_LOGS: 'form-logs',
  SUBFORM_LOGS: 'subform-logs',
  WORKFLOWS_LOGS: 'workflows-logs',
  ORG_STRUCTURE_LOGS: 'org-structure-logs',
  NOTIFICATIONS_SLA_LOGS: 'notifications-sla-logs',
  COMMENTS: 'comments',
  COMMENTS_LOGS: 'comments-logs',
  ADDITIONAL_DOCUMENTS: 'additional-documents',
  ADDITIONAL_DOCUMENTS_LOGS: 'additional-documents-logs',
  EXTERNAL_MY_ORG_PRIVILEGES: 'external-my-org-structure',
};

/**
 * Maps base resource names to their corresponding audit log resource names.
 * Single source of truth used by both routesConfig (route generation)
 * and routePermissions (permission mapping).
 */
export const LOG_RESOURCE_MAP = {
  [RESOURCES.ROLE_GROUPS]: RESOURCES.ROLE_GROUPS_LOGS,
  [RESOURCES.ADMIN_USERS]: RESOURCES.ADMIN_USERS_LOGS,
  [RESOURCES.EXTERNAL_USERS]: RESOURCES.EXTERNAL_USERS_LOGS,
  [RESOURCES.EXTERNAL_ORGANIZATIONS_CATEGORIES]:
    RESOURCES.EXTERNAL_ORGANIZATIONS_CATEGORIES_LOGS,
  [RESOURCES.SUBFORM]: RESOURCES.SUBFORM_LOGS,
  [RESOURCES.FORM]: RESOURCES.FORM_LOGS,
  [RESOURCES.WORKFLOWS]: RESOURCES.WORKFLOWS_LOGS,
  [RESOURCES.ORG_STRUCTURE]: RESOURCES.ORG_STRUCTURE_LOGS,
  [RESOURCES.NOTIFICATIONS_SLA]: RESOURCES.NOTIFICATIONS_SLA_LOGS,
  [RESOURCES.COMMENTS]: RESOURCES.COMMENTS_LOGS,
  [RESOURCES.ADDITIONAL_DOCUMENTS]: RESOURCES.ADDITIONAL_DOCUMENTS_LOGS,
};

/**
 * Resource utility functions
 * Provides dynamic resource filtering and categorization
 */

/**
 * Get all audit log resources dynamically
 * Automatically includes any new resources ending with '-logs'
 * @returns {Array<string>} Array of log resource names
 */
export const getAllLogResources = () => {
  return Object.values(RESOURCES).filter((resource) =>
    resource.endsWith('-logs')
  );
};
